import React, { Component } from 'react';
import UploadTile from '../../Tile/UploadTile/UploadTile';
import {Routes, Route} from 'react-router-dom';

class Upload extends Component{

    render() {
        let tileupload= null;
        return(
            <div className="UploadContainer">
                <UploadTile />
            </div>
        );
      }
}

export default Upload;